PF.FileList.Item = class Item extends PF.List.Item
	{
	static get options()
		{
		return {};
		}

	onRender(event)
		{
		super.onRender(event);

		this.dom.img.bindAttributes();

		this.bindDom({preloader: 'hide', img: 'show'}, 'model.file.options.isUpload');

		if (this.model.options.isNewRecord === true)
			{
			this.model.get('file').saveFile();
			}
		}

	delete(callDelete = true)
		{
		this.list.fileList.models.removeModel(this.model);
		if (callDelete)
			{
			this.list.fileList.models.delete();
			}
		}
	};

PF.FileList.Item.Select = class FileItemSelect extends PF.Trait
	{
	initTrait()
		{
		super.initTrait();

		this.bindCheck();
		// this.bindDom({selectInput: ['disabled'], selectCheckbox: 'show'}, 'list.selectMode');
		// this.dom.selectInput.bindAll();
		// this.connect('dom.selectInput.value', 'selectState');

		this.dom.item.on('fastClick@open', () => this.trigger('open'));
		this.dom.item.on('fastClick@select', () => {
			this.selectState = !this.selectState;
			this.list.fileList.selectMode = this.list.fileList.selected.length > 0;
		});

		this.list.fileList.onValue('selectMode', false, () => {
			this.dom.item.pauseEvent('fastClick@select');
			this.dom.item.resumeEvent('fastClick@open');
		});
		this.list.fileList.onValue('selectMode', true, () => {
			this.dom.item.pauseEvent('fastClick@open');
			this.dom.item.resumeEvent('fastClick@select');
		});

		this.dom.item.on('hold', () => {
			this.list.fileList.selectMode = !this.list.fileList.selectMode;
			this.selectState = true;
		});

		this.onValue('selectState', true, () => this.list.fileList.selected.push(this));
		this.onValue('selectState', false, () => {
			let index = this.list.fileList.selected.indexOf(this);
			this.list.fileList.selected.splice(index, 1);
		});

		this.model.on('delete-success', () => {
			this.selectState = false;
		});
		}

	bindCheck()
		{
		}
	};